// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3QWH2","col":"CardReaderDesc_col__bXPJK","label":"CardReaderDesc_label__2meHE"};